
import _ from "lodash";
import { map } from "constants/screenElements/fundTable";
import numberFormatter from "utils/numberFormatter";

import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatDecimalAsInteger,
  formatYears,
  formatDaysToYears,
  formatDate,
  formatNumberTwoDecimal,
  formatNumberTwoDecimalWithRounding,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal,
  formatDscr
} from "./formattersv2";

const {
  CASH_EQUITY,
  PROJECTED_RATE,
  AGGREGATE_EQUITY,
  MAX_RECOURSE,
  DEBT_MF_UNIT,
  DEBT_RSF,
  MF_UNITS,
  RSF,
  PREPAYMENT,
  PROPERTY_VALUE,
  NOI,
  NOI_ACTUAL,
  UNHEDGED_PV01,
  HEDGED_PV01,
  FIXED_FLOATING_HEDGED_DEBT_PERCENT,
  DSCR,
  DSCR_ACTUAL,
  DSCR_LENDER,
  DEBT_YIELD,
  LTV,
  UNFUNDED_COMMITTED_DEBT,
  TOTAL_OUTSTANDING_DEBT,
  WEIGHTED_AVERAGE_INTEREST_RATE,
  WEIGHTED_MATURITY,
  REFI_PROCEEDS,
  REFI_CASH_OUT,
  ALL_IN_EFFECTIVE_RATE
} = map;

export default {
  [CASH_EQUITY]: formatCurrency,
  [PROJECTED_RATE]: formatRate,
  [AGGREGATE_EQUITY]: formatCurrency,
  [MAX_RECOURSE]: notImplemented,
  [DEBT_MF_UNIT]: formatCurrency,
  [DEBT_RSF]: formatCurrencyTwoDecimal,
  [MF_UNITS]: formatDecimalAsInteger,
  [RSF]: formatNumberTwoDecimalWithRounding,
  [PREPAYMENT]: formatCurrency,
  [PROPERTY_VALUE]: formatCurrency,
  [NOI]: formatCurrencyTwoDecimal,
  [NOI_ACTUAL]: formatCurrencyTwoDecimal,
  [UNHEDGED_PV01]: notImplemented,
  [HEDGED_PV01]: notImplemented,
  [FIXED_FLOATING_HEDGED_DEBT_PERCENT]: (fixedDebt, floatingDebt, hedgedDebt) => {
    const fD = fixedDebt ? `${Math.round(fixedDebt * 100)}%` : "\u2014";
    const flD = floatingDebt ? `${Math.round(floatingDebt * 100)}%` : "\u2014";
    const hD = hedgedDebt ? `${Math.round(hedgedDebt * 100)}%` : "\u2014";

    return `${fD} | ${flD} | ${hD}`;
  },
  [DSCR]: formatDscr,
  [DSCR_ACTUAL]: formatDscr,
  [DSCR_LENDER]: formatDscr,
  [DEBT_YIELD]: formatRate,
  [LTV]: formatRate,
  [UNFUNDED_COMMITTED_DEBT]: formatCurrency,
  [TOTAL_OUTSTANDING_DEBT]: formatCurrency,
  [WEIGHTED_AVERAGE_INTEREST_RATE]: formatRate,
  [WEIGHTED_MATURITY]: notImplemented,
  [REFI_PROCEEDS]: formatCurrency,
  [REFI_CASH_OUT]: formatCurrency,
  [ALL_IN_EFFECTIVE_RATE]: formatRate
};
